import { useAuth } from "react-oidc-context";
import { Navigate } from "react-router-dom";
import { type ReactNode } from "react";

export function PrivateRoute({ children }: { children: ReactNode }) {
  const auth = useAuth();
  if (!auth.isAuthenticated) {
    return <Navigate to="/welcome" replace />;
  }
  return <>{children}</>;
}

export function PublicRoute({ children }: { children: ReactNode }) {
  const auth = useAuth();
  if (auth.isAuthenticated) {
    return <Navigate to="/discoverAgents" replace />;
  }
  return <>{children}</>;
}
